/** 利用者向けの接続種別名。通信契約の識別子・ラベルは変更しない。 */
export function storageKindLabel(kind: string, label: string): string {
  if (kind === "local_folder") return "ローカルフォルダ";
  if (kind === "smb") return "共有フォルダ";
  return label;
}
